export default __webpack_public_path__ + "static/media/UniversLTStd-BlackObl.223b3b73.otf";